// export API
export { createTheme, defaultTheme } from './theme';
